<form [formGroup]="form">
  <span>{{'PERCENTAGE' | translate}}</span>
  <label>
    <input min="0" max="100" type="number" placeholder="90%" formControlName="percent" class="light-grey-placeholder">
    <cc-input-errors
      [form]="form"
      inputName="percent"
      [errors]="[{'numbers': 'Please enter a % value'}, {'required': 'The field is required'}, 
      {'min': 'The minimum value is 1'}, {'max': 'The maximum value is 100'} ]"></cc-input-errors>
  </label>
</form>
